// hooks/useReminders.js
import { useState, useEffect, useCallback } from 'react';
import { reminderApi } from '../api/reminders';
import toast from 'react-hot-toast';

export const useReminders = () => {
  const [reminders, setReminders] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReminders = useCallback(async () => {
    setLoading(true);
    try {
      const response = await reminderApi.getAll();
      setReminders(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      toast.error('Failed to fetch reminders');
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSummary = useCallback(async () => {
    try {
      const response = await reminderApi.getSummary();
      setSummary(response.data);
    } catch (err) {
      toast.error('Failed to fetch summary');
    }
  }, []);

  const getHighPriority = useCallback(async () => {
    try {
      const response = await reminderApi.getHighPriority();
      return response.data;
    } catch (err) {
      toast.error('Failed to fetch high priority reminders');
      throw err;
    }
  }, []);

  useEffect(() => {
    fetchReminders();
    fetchSummary();
  }, [fetchReminders, fetchSummary]);

  return { 
    reminders, 
    summary, 
    loading, 
    error, 
    fetchReminders, 
    fetchSummary,
    getHighPriority 
  };
};